import React, { useCallback, useState, useEffect } from "react";
import {
  Text,
  TouchableOpacity,
  View,
  FlatList,
  TextInput,
  Image,
} from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import styles from "./styles";
import HeaderTabs from "../../components/HeaderTabs";
import { FormattedMessage } from "react-intl";
import { ScrollView } from "react-native-web";
import GoBackButton from "../../components/GoBackButton";
import { When, If, Then, Else } from "react-if";
import CalculadoraImage from "../../../assets/calculadora.png";

const veiculos = {
  items: [
    { name: "Carro" },
    { name: "Moto" },
    { name: "Ônibus" },
    { name: "Caminhão" },
  ],
};

const subcategories = {
  Frota: {
    labelTipoDado: "Insira o Total de Combustível Consumido (Litros)",
    items: [
      { name: "Gasolina Comum", emissionFactor: 2.19 },
      { name: "Etanol Hidratado", emissionFactor: 0.5 },
      { name: "Diesel", emissionFactor: 2.68 },
      { name: "GNV (Gás Natural Veicular)", emissionFactor: 2.29 },
      { name: "GNL (Gás Natural Liquefeito)", emissionFactor: 2.75 },
      { name: "Óleo Diesel S10", emissionFactor: 2.68 },
    ],
  },

  Combustível: {
    labelTipoDado: "Insira a quantidade em litros",
    items: [
      { name: "Gasolina Comum", emissionFactor: 2.19 },
      { name: "Etanol Hidratado", emissionFactor: 0.5 },
      { name: "Diesel", emissionFactor: 2.68 },
      { name: "GNV (Gás Natural Veicular)", emissionFactor: 2.29 },
      { name: "GNL (Gás Natural Liquefeito)", emissionFactor: 2.75 },
      { name: "Óleo Diesel S10", emissionFactor: 2.68 },
    ],
  },

  "Pegada Hídrica": {
    labelTipoDado: "Insira a quantidade em m³ de Água",
    items: [
      { name: "Água da Rede Pública (Tratada)", emissionFactor: 0.344 },
      { name: "Água Subterrânea (Poço Artesiano)", emissionFactor: 0.18 },
      { name: "Água de Reuso (Tratada)", emissionFactor: 0.68 },
      { name: "Água Dessalinizada", emissionFactor: 3.7 },
      { name: "Água da Chuva (Captação e Uso Direto)", emissionFactor: 0.05 },
      { name: "Água Subterrânea e Efluente de Rio", emissionFactor: 0.18 },
    ],
  },

  "Corte de Barba e Cabelo": {
    labelTipoDado: "Insira a quantidade de Cortes ou Barbas",
    items: [
      { name: "Corte de Cabelo", emissionFactor: 0.0144 },
      { name: "Corte de Barba", emissionFactor: 0.0108 },
    ],
  },

  "Serviços Petshop": {
    labelTipoDado: "Insira a quantidade de Serviços de Tosa, Banho ou Secagem",
    items: [
      { name: "Tosa, Banho e Secagem", emissionFactor: 0.1405 },
      { name: "Banho e Secagem", emissionFactor: 0.0933 },
    ],
  },

  "Passagens Aéreas": {
    labelTipoDado: "Insira a quantidade de Passagens",
    items: [{ name: "Bilhete Aéreo em Papel", emissionFactor: 0.007 }],
  },

  "Bagagens Aéreas": {
    labelTipoDado: "Insira a quantidade de Bagagens",
    items: [{ name: "Etiqueta de Bagagem", emissionFactor: 0.015 }],
  },

  "Viagens Aéreas": {
    labelTipoDado: "Insira a distância em km do seu Voo",
    items: [
      { name: "Pequeno Porte Privado", emissionFactor: 0.1007 },
      { name: "Aviões Comerciais", emissionFactor: 0.0586 },
    ],
  },

  "Passagens de Ônibus": {
    labelTipoDado: "Insira quantidade de Passagens",
    items: [{ name: "Passagem de Ônibus", emissionFactor: 0.001 }],
  },

  "Etiquetas de Bagagens de Ônibus": {
    labelTipoDado: "Insira quantidade  de Bagagens",
    items: [{ name: "Etiqueta de Bagagem", emissionFactor: 0.001 }],
  },

  "Viagens de Ônibus Intermunicipais e Interestaduais": {
    labelTipoDado: "Insira a distância da Viagem e km",
    items: [
      { name: "Ônibus Urbano", emissionFactor: 0.0447 },
      { name: "Ônibus Intermunicipal", emissionFactor: 0.0279 },
    ],
  },

  Veículos: {
    labelTipoDado: "Insira a quantidade de km percorridos pelo Veículo",
    items: [
      { name: "Motocicleta (Gasolina)", emissionFactor: 0.0793 },
      { name: "Veículo Passeio (Gasolina)", emissionFactor: 0.23625 },
      { name: "Veículo Passeio (Etanol)", emissionFactor: 0.11335 },
      { name: "Veículo Passeio (GNV)", emissionFactor: 0.18315 },
      { name: "Veículo Elétrico", emissionFactor: 0.01635 },
    ],
  },

  "Revisão de Veículos": {
    labelTipoDado: "Informe o número de Veículos por Revisão",
    items: [
      { name: "Motocicleta", emissionFactor: 20 },
      { name: "Veículo Passeio (Gasolina)", emissionFactor: 50 },
      { name: "Veículo Passeio (Etanol)", emissionFactor: 50 },
      { name: "Veículo Passeio (GNV)", emissionFactor: 50 },
      { name: "Veículo Elétrico", emissionFactor: 25 },
      { name: "Ônibus/Caminhões", emissionFactor: 150 },
    ],
  },

  "Troca de Pneu": {
    labelTipoDado: "Informe quantos Pneus foram Trocados",
    items: [
      { name: "Motocicleta", emissionFactor: 8.5 },
      {
        name: "Veículo Passeio (Gasolina, Etanol, GNV, Elétrico)",
        emissionFactor: 12.5,
      },
      { name: "Ônibus/Caminhões", emissionFactor: 37.5 },
    ],
  },

  "Corrida de Rua": {
    labelTipoDado:
      "Indique o Número de Eventos / Indique o Número de Atletas por Evento",
    items: [
      { name: "Atleta", emissionFactor: 10.4 },
      { name: "Evento", emissionFactor: 17 },
    ],
  },

  "Transações Financeiras": {
    labelTipoDado: "Indique o Número de Transações Realizadas",
    items: [
      { name: "PIX", emissionFactor: 0.004 },
      { name: "Cartão de Crédito (sem fatura)", emissionFactor: 0.004 },
      {
        name: "Cartão de Crédito (com fatura impressa)",
        emissionFactor: 0.054,
      },
      { name: "Cartão de Débito", emissionFactor: 0.004 },
      { name: "TED", emissionFactor: 0.004 },
      { name: "Boleto Virtual", emissionFactor: 0.004 },
      { name: "Boleto Impresso", emissionFactor: 0.054 },
      { name: "Cheque", emissionFactor: 0.054 },
    ],
  },

  "Cartão de Plástico Físico": {
    labelTipoDado: "Indique o Número de Cartões Plásticos Emitidos",
    items: [
      { name: "Cartão/ débito/crédito ou de acesso", emissionFactor: 0.06 },
    ],
  },

  "Energia Elétrica por kWh": {
    labelTipoDado: "Indique a quantidade de kWh Consumidos",
    items: [{ name: "kwh Consumido", emissionFactor: 0.08 }],
  },

  "Material Impresso": {
    labelTipoDado: "Indique a quantidade  utilizada em kg",
    items: [
      { name: "Preto e Branco", emissionFactor: 0.002 },
      { name: "Colorido", emissionFactor: 0.002 },
    ],
  },

  Guardanapos: {
    labelTipoDado: "Indique quantas unidades foram utilizadas",
    items: [
      { name: "Toalha de papel (virgem)", emissionFactor: 0.007 },
      { name: "Toalha de papel (reciclado)", emissionFactor: 0.005 },
      { name: "Guardanapo de papel (virgem)", emissionFactor: 0.003 },
      { name: "Guardanapo de papel (reciclado)", emissionFactor: 0.002 },
      { name: "Papel toalha (virgem)", emissionFactor: 0.007 },
      { name: "Papel toalha (reciclado)", emissionFactor: 0.005 },
      { name: "Papel higiênico (virgem)", emissionFactor: 0.001 },
      { name: "Papel higiênico (reciclado)", emissionFactor: 0.001 },
      { name: "Toalha de pano (produção)", emissionFactor: 0.45 },
      { name: "Guardanapo de pano (produção)", emissionFactor: 0.08 },
    ],
  },

  "Mídias Sociais": {
    labelTipoDado: "Indique o número de Visualizações",
    items: [
      { name: "Postagem Simples (texto/imagem)", emissionFactor: 0.001 },
      { name: "Postagem com Vídeo (1 minuto)", emissionFactor: 0.011 },
      { name: "Impulsionamento (1 visualização)", emissionFactor: 0.001 },
    ],
  },

  //PRECISA DE KM PERCORRIDO E KG DO ITEM PRA CALCULAR
  "Serviços de Logística e Entrega Última Milha": {
    labelTipoDado: "Indique a quantidade de km percorrida",
    items: [
      { name: "Moto", emissionFactor: 0.07 },
      { name: "Moto Elétrica", emissionFactor: 0.018 },
      { name: "Patinete Elétrico", emissionFactor: 0.0004 },
      { name: "Bicicleta Elétrica", emissionFactor: 0.0005 },
      { name: "Carro a Gasolina", emissionFactor: 0.231 },
      { name: "Carro a Álcool", emissionFactor: 0.157 },
      { name: "Caminhão Leve (até 2,8t)", emissionFactor: 0.3 },
      { name: "Caminhão Pesado", emissionFactor: 0.8 },
      { name: "Minivan Gasolina (até 2,8t)", emissionFactor: 0.4 },
      { name: "Minivan Diesel(até 2,8t)", emissionFactor: 0.4 },
    ],
  },

  Embalagens: {
    labelTipoDado:
      "Insira a quantidade em gramas do material que compõe suas embalagens. Caso haja mais de um material, insira a soma dos volumes",
    items: [
      {
        name: "Plásticos (Plásticos Rígidos), Material (PET), Exemplos (Garrafas, frascos)",
        emissionFactor: 0.0021,
      },
      {
        name: "Plásticos (Plásticos Rígidos), Material (PEAD), Exemplos (Frascos de produtos de limpeza)",
        emissionFactor: 0.0018,
      },
      {
        name: "Plásticos (Plásticos Rígidos), Material (PP), Exemplos (Tampas de garrafas)",
        emissionFactor: 0.0019,
      },
      {
        name: "Plásticos (Plásticos Flexíveis), Material (PEBD), Exemplos (Sacos plásticos)",
        emissionFactor: 0.0018,
      },
      {
        name: "Plásticos (Plásticos Flexíveis), Material (BOPP), Exemplos (Snacks, biscoitos)",
        emissionFactor: 0.002,
      },
      {
        name: "Plásticos (Plásticos Espumados), Material (PS), Exemplos (Copos descartáveis)",
        emissionFactor: 0.0022,
      },
      {
        name: "Plásticos (Plásticos Espumados), Material (EPS), Exemplos (Caixas térmicas)",
        emissionFactor: 0.003,
      },
      {
        name: "Plásticos (Plásticos Rígidos), Material (PVC), Exemplos (Blister packs)",
        emissionFactor: 0.003,
      },
      {
        name: "Papel e Papelão (Papelão Rígido), Material (Papelão Ondulado), Exemplos (Caixas de transporte)",
        emissionFactor: 0.0008,
      },
      {
        name: "Papel e Papelão (Papel Flexível), Material (Papel Kraft), Exemplos (Sacos de papel)",
        emissionFactor: 0.0007,
      },
      {
        name: "Papel e Papelão (Papel Especial), Material (Cartolina e Papel Couché), Exemplos (Caixas de presentes)",
        emissionFactor: 0.0009,
      },
      {
        name: "Papel e Papelão (Laminados de Papel), Material (Papel com PE ou Alumínio), Exemplos (Lanches)",
        emissionFactor: 0.004,
      },
      {
        name: "Vidro (Vidro Comum), Material (Vidro Comum), Exemplos (Garrafas de bebidas)",
        emissionFactor: 0.0014,
      },
      {
        name: "Vidro (Vidro Colorido), Material (Vidro Âmbar), Exemplos (Frascos de cosméticos)",
        emissionFactor: 0.0015,
      },
      {
        name: "Vidro (Vidro Reforçado), Material (Vidro Reforçado), Exemplos (Frascos de medicamentos)",
        emissionFactor: 0.0015,
      },
      {
        name: "Vidro (Vidro Reciclado), Material (Vidro Reciclado), Exemplos (Garrafas recicladas)",
        emissionFactor: 0.0012,
      },
      {
        name: "Metais (Metais Leves), Material (Alumínio), Exemplos (Latas de refrigerante)",
        emissionFactor: 0.0092,
      },
      {
        name: "Metais (Metais Pesados), Material (Aço), Exemplos (Latas de conservas)",
        emissionFactor: 0.0023,
      },
      {
        name: "Metais (Metais Preciosos), Material (Estanho), Exemplos (Enlatados)",
        emissionFactor: 0.008,
      },
      {
        name: "Laminados e Compostos (Laminados Flexíveis), Material (Plástico, Alumínio), Exemplos (Embalagens flexíveis de alimentos)",
        emissionFactor: 0.005,
      },
      {
        name: "Laminados e Compostos (Laminados Cartonados), Material (Papelão, PE, Alumínio), Exemplos (Leite, sucos)",
        emissionFactor: 0.0035,
      },
      {
        name: "Naturais e Biodegradáveis (Fibras Naturais), Material (Fibra de Bambu), Exemplos (Embalagens ecológicas)",
        emissionFactor: 0.0025,
      },
      {
        name: "Naturais e Biodegradáveis (Bioplásticos), Material (PLA (Ácido Polilático)), Exemplos (Sacos biodegradáveis)",
        emissionFactor: 0.001,
      },
      {
        name: "Naturais e Biodegradáveis (Bioplásticos), Material (Amido de Milho), Exemplos (Pratos descartáveis)",
        emissionFactor: 0.0015,
      },
      {
        name: "Madeira (Madeira Reciclada), Material (Madeira Reciclada), Exemplos (Embalagens de frutas)",
        emissionFactor: 0.0009,
      },
      {
        name: "Madeira (Madeira Tratada), Material (Madeira Tratada), Exemplos (Caixas de luxo)",
        emissionFactor: 0.0012,
      },
      {
        name: "Papel e Papelão (Papel Higiênico), Material (Papel Higiênico), Exemplos (Rolos de papel)",
        emissionFactor: 0.0008,
      },
      {
        name: "Remédios (Blister de Medicamentos), Material (PVC, Alumínio), Exemplos (Comprimidos)",
        emissionFactor: 0.004,
      },
    ],
  },
};

export default function StampsCalculator() {
  const [categorySearchTerm, setCategorySearchTerm] = useState("");
  const [subcategorySearchTerm, setSubcategorySearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [emissionFactor, setEmissionFactor] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [result, setResult] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [mileage, setMileage] = useState("");
  const [kmRodados, setKmRodados] = useState("");
  const [isSubcategoryFocused, setIsSubcategoryFocused] = useState(false);
  const [isFrota, setIsFrota] = useState(false);
  const [numVeiculos, setNumVeiculos] = useState("");
  const [veiculo, setVeiculo] = useState("");

  const filteredCategories = Object.keys(subcategories)
    .filter((category) =>
      category.toLowerCase().includes(categorySearchTerm.toLowerCase())
    )
    .sort((a, b) => a.localeCompare(b));

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setCategorySearchTerm(category);
    setIsFocused(false);
    setSelectedSubcategory(null);
    setSubcategorySearchTerm("");
    setEmissionFactor(0);
    setInputValue("");
    setMileage("");
    setResult(null);
  };

  useEffect(() => {
    setIsFrota(selectedCategory === "Frota");
  }, [selectedCategory]);

  const clearForm = () => {
    setCategorySearchTerm("");
    setSubcategorySearchTerm("");
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setEmissionFactor(0);
    setInputValue("");
    setResult(null);
    setIsFocused(false);
    setIsSubcategoryFocused(false);
  };

  const filteredSubcategories =
    selectedCategory && subcategories[selectedCategory]
      ? subcategories[selectedCategory].items.filter((subcategory) =>
          subcategory.name
            .toLowerCase()
            .includes(subcategorySearchTerm.toLowerCase())
        )
      : [];

  useFocusEffect(
    useCallback(() => {
      return () => {
        setCategorySearchTerm("");
        setSubcategorySearchTerm("");
        setSelectedCategory(null);
        setSelectedSubcategory(null);
        setEmissionFactor(0);
        setInputValue("");
        setResult(null);
        setIsFocused(false);
        setIsSubcategoryFocused(false);
      };
    }, [])
  );

  const handleSubcategorySelect = (subcategory) => {
    setSelectedSubcategory(subcategory.name);
    setEmissionFactor(subcategory.emissionFactor);
    setIsSubcategoryFocused(false);
    setSubcategorySearchTerm(subcategory.name);
  };

  const calculateEmission = () => {
    const value = parseFloat(inputValue);
    const mileageValue = parseFloat(mileage);

    if (!isNaN(value) && emissionFactor) {
      let calculated;
      let resultDivisao;
      let resultMult;

      if (
        selectedCategory === "Serviços de Logística e Entrega Última Milha" &&
        !isNaN(mileageValue)
      ) {
        calculated = Math.ceil(value * emissionFactor + mileageValue * 0.2);
      } else if (selectedCategory === "Frota") {
        resultDivisao = kmRodados / numVeiculos / (kmRodados / value);
        resultMult = resultDivisao * numVeiculos;
        calculated = Math.ceil(resultMult * emissionFactor);
      } else {
        calculated = Math.ceil(value * emissionFactor);
      }
      console.log(
        "km",
        kmRodados,
        "num",
        numVeiculos,
        "combu",
        value,
        "resDivi",
        resultDivisao,
        "resMul",
        resultMult,
        "calculated",
        calculated
      );
      setResult(calculated);
    }
  };

  return (
    <>
      <HeaderTabs title="Calculadora de Selos" />
      <ScrollView>
        <View style={styles.outerContainer}>
          <View style={{ flexDirection: "column" }}>
            <View style={styles.container}>
              <Text style={styles.subcategoryLabel}>
                <FormattedMessage id="stampsCalculator.lblSelecioneCategoria" />
              </Text>

              <FormattedMessage id="stampsCalculator.placeholderCategoria">
                {(placeholder) => (
                  <TextInput
                    placeholderTextColor="#FFFFFF"
                    style={styles.searchInput}
                    placeholder={placeholder}
                    value={categorySearchTerm}
                    onFocus={() => setIsFocused(true)}
                    onChangeText={(text) => {
                      setCategorySearchTerm(text);
                      setIsFocused(true);
                    }}
                  />
                )}
              </FormattedMessage>

              <When condition={isFocused}>
                <FlatList
                  data={filteredCategories}
                  style={{ backgroundColor: "#DAEBEF" }}
                  keyExtractor={(item) => item}
                  renderItem={({ item }) => (
                    <TouchableOpacity
                      style={styles.categoryItem}
                      onPress={() => handleCategorySelect(item)}
                    >
                      <Text>{item}</Text>
                    </TouchableOpacity>
                  )}
                />
              </When>

              <When condition={selectedCategory}>
                <View style={styles.subcategoryContainer}>
                  <Text style={styles.subcategoryLabel}>
                    <FormattedMessage id="stampsCalculator.lblCategoriaSelecionada" />
                    {selectedCategory}
                  </Text>

                  <FormattedMessage id="stampsCalculator.placeholderSubCat">
                    {(placeholder) => (
                      <TextInput
                        placeholderTextColor="#FFFFFF"
                        style={styles.searchInput}
                        placeholder={placeholder}
                        value={subcategorySearchTerm}
                        onFocus={() => setIsSubcategoryFocused(true)}
                        onChangeText={(text) => {
                          setSubcategorySearchTerm(text);
                          setIsSubcategoryFocused(true);
                        }}
                      />
                    )}
                  </FormattedMessage>

                  <When
                    condition={
                      isSubcategoryFocused && filteredSubcategories.length > 0
                    }
                  >
                    <FlatList
                      style={{ backgroundColor: "#DAEBEF" }}
                      data={filteredSubcategories}
                      keyExtractor={(item) => item.name}
                      renderItem={({ item }) => (
                        <TouchableOpacity
                          style={styles.categoryItem}
                          onPress={() => handleSubcategorySelect(item)}
                        >
                          <Text>{item.name}</Text>
                        </TouchableOpacity>
                      )}
                    />
                  </When>

                  <When condition={selectedSubcategory}>
                    <Text style={styles.subcategoryLabel}>
                      <FormattedMessage
                        id={
                          isFrota
                            ? "Tipo de Combustível: "
                            : "stampsCalculator.lblSubcatSelecionada"
                        }
                      />
                      {selectedSubcategory}
                    </Text>
                  </When>

                  <View style={styles.hrLine} />

                  <When condition={selectedSubcategory}>
                    <Text style={styles.subcategoryLabel}>
                      {subcategories[selectedCategory]?.labelTipoDado ||
                        "Insira um valor"}
                    </Text>
                  </When>

                  <FormattedMessage id="stampsCalculator.placeholderQuantidade">
                    {(placeholder) => (
                      <TextInput
                        placeholderTextColor="#FFFFFF"
                        style={styles.searchInput}
                        placeholder={placeholder}
                        keyboardType="numeric"
                        value={inputValue}
                        onChangeText={(text) => setInputValue(text)}
                      />
                    )}
                  </FormattedMessage>

                  {/*       <Text style={styles.subcategoryLabel}>
                        Selecione o Tipo de Veículo
                      </Text>
                      <FlatList
                        data={veiculos.items}
                        style={{ backgroundColor: "#DAEBEF" }}
                        keyExtractor={(item) => item.name}
                        renderItem={({ item }) => (
                          <TouchableOpacity
                            style={styles.categoryItem}
                            onPress={() => handleCategorySelect(item)}
                          >
                            <Text>{item.name}</Text>
                          </TouchableOpacity>
                        )}
                      /> */}
                  <If condition={isFrota}>
                    <Then>
                      <Text style={styles.subcategoryLabel}>
                        Insira a Quantidade de Veículos na Frota
                      </Text>
                      <TextInput
                        style={styles.searchInput}
                        placeholder={"Número de Veículos"}
                        keyboardType="numeric"
                        value={numVeiculos}
                        onChangeText={(text) => setNumVeiculos(text)}
                      />
                      <Text style={styles.subcategoryLabel}>
                        Insira o total de Km rodados pela frota
                      </Text>
                      <TextInput
                        style={styles.searchInput}
                        placeholder={"Kms rodados"}
                        keyboardType="numeric"
                        value={kmRodados}
                        onChangeText={(text) => setKmRodados(text)}
                      />
                    </Then>
                  </If>

                  <If
                    condition={
                      selectedCategory ===
                      "Serviços de Logística e Entrega Última Milha"
                    }
                  >
                    <Then>
                      <When condition={selectedSubcategory}>
                        <Text style={styles.subcategoryLabel}>
                          <FormattedMessage id="stampsCalculator.lblKmPercorrido" />
                        </Text>
                      </When>
                      <FormattedMessage id="stampsCalculator.placeholderPesoItem">
                        {(placeholder) => (
                          <TextInput
                            style={styles.searchInput}
                            placeholder={placeholder}
                            keyboardType="numeric"
                            value={mileage}
                            onChangeText={(text) => setMileage(text)}
                          />
                        )}
                      </FormattedMessage>
                    </Then>
                  </If>

                  <TouchableOpacity
                    style={styles.btnCalcular}
                    onPress={calculateEmission}
                  >
                    <Text style={styles.txtBtnCalcular}>
                      <FormattedMessage id="stampsCalculator.btnTxtCalcularEmissao" />
                    </Text>
                  </TouchableOpacity>

                  <View style={{ marginBottom: 20 }}>
                    <When condition={result !== null}>
                      <>
                        <View style={styles.hrLine} />

                        <View style={{ flexDirection: "column" }}>
                          <Text style={styles.txtNecessarios}>
                            <FormattedMessage id="stampsCalculator.lblSelosNecessarios" />{" "}
                          </Text>
                          <View style={styles.containerResultado}>
                            <Text style={styles.result}>{result} </Text>
                            <If condition={result === 1}>
                              <Then>
                                <Text style={styles.selosNecessarios}>
                                  Selo{" "}
                                </Text>
                              </Then>
                              <Else>
                                <Text style={styles.selosNecessarios}>
                                  Selos{" "}
                                </Text>
                              </Else>
                            </If>
                            <Text style={styles.selosNecessarios}>
                              {categorySearchTerm}
                            </Text>
                          </View>
                        </View>
                      </>
                    </When>
                  </View>
                </View>
              </When>
            </View>
          </View>
          <View style={{ flexDirection: "column" }}>
            <Image source={CalculadoraImage} style={styles.imgPegadaCarbono} />
            <GoBackButton style={styles.goBackBtn} />
          </View>
        </View>
      </ScrollView>
    </>
  );
}
